module.exports = __webpack_public_path__ + "static/media/ChevronDown.72575b5f.svg";